export default __webpack_public_path__ + "static/media/JULD-BNB.5b35949e.svg";